import ProductAddToCartHOC from '@common/components/ProductAddToCartHOC';
import { addProductToCart } from '@common/store/cart/slice';
import { addToast } from '@common/store/toasts/slice';
import Gallery from '@components/Gallery';
import ProductAddToCart from '@components/ProductAddToCart';
import StarRating from '@components/Rating/StarRating';
import Editor from '@lib/Editor';
import classnames from 'classnames';
import React from 'react';

import Product from '../../models/Product';
import { subtractProductFromCart } from '../../store/cart/slice';

interface EventProps {
  product: Product;
  addProductToCart: typeof addProductToCart;
  cartProductQuantity: number;
  addToast: typeof addToast;
  storeType: string;
  review: number;
  productReview?: unknown;
  quickView?: boolean;
  subtractProductFromCart: typeof subtractProductFromCart;
  wishListFeature?: boolean;
  productVideoFeature?: boolean;
}

const Event: React.FC<EventProps> = ({
  product,
  addProductToCart,
  subtractProductFromCart,
  cartProductQuantity,
  addToast,
  storeType,
  quickView,
  review,
  wishListFeature,
  productVideoFeature,
}) => {
  return (
    <ProductAddToCartHOC
      variantSetToMinQuantity={true}
      disableSuccessToasts={() => false}
      product={product}
      render={(hocArgs) => {
        const { finalProduct } = hocArgs;
        const StarRatingValue = finalProduct.averageRating;
        return (
          <div
            className={classnames('md:container mx-auto ', {
              'mb-48': !quickView,
              'mb-20': quickView,
            })}
          >
            <div
              className={classnames('flex flex-col md:flex-row', {
                'justify-center': quickView,
              })}
            >
              <div
                className={classnames('relative', {
                  'w-full md:flex-670 md:max-w-670 mb-16': !quickView,
                  'w-full md:w-394 mr-24': quickView,
                })}
              >
                <Gallery
                  images={finalProduct.images.length ? finalProduct.images : product.images}
                  quickView={quickView}
                  imageDescription={`${finalProduct.images.length ? finalProduct.title : product.title}${
                    finalProduct?.optionValues?.length ? '_' + finalProduct?.optionValues.join('_') : ''
                  }`}
                  productVideoUrl={finalProduct.productVideoUrl}
                  product={product}
                  productVideoEnabled={productVideoFeature ? finalProduct.productVideoEnabled : false}
                />
              </div>
              <div
                className={classnames('', {
                  'flex-1 px-16 md:pl-16 md:pr-0 md:min-w-400 z-1 relative': !quickView,
                  'flex-1 px-16 md:w-394': quickView,
                })}
              >
                <div className="sticky top-80 text-center md:text-left">
                  <div className="flex-1 flex justify-center md:justify-start">
                    {parseInt(StarRatingValue) > 0 ? (
                      <div className=" flex pr-4 ">
                        <StarRating
                          rating={parseInt(StarRatingValue) ? parseInt(StarRatingValue) : 0}
                          halfRating={parseInt(StarRatingValue) ? (Number.isInteger(StarRatingValue) ? 0 : 1) : 0}
                          total={5}
                          isInteractive={false}
                          className="mr-4"
                        />
                      </div>
                    ) : null}
                    {review > 0 ? (
                      <div
                        onClick={() => {
                          if (!quickView) {
                            const elmntToView = document.getElementById('Review');
                            elmntToView.scrollIntoView();
                          }
                        }}
                        className="text-theme cursor-pointer text-opacity-60 underline text-12 md:text-14 pl-6 font-medium"
                        font-customisation="para-text"
                      >
                        {review} Reviews
                      </div>
                    ) : (
                      <button className="text-theme underline">Write a Review</button>
                    )}
                  </div>
                  <div
                    className="text-28 md:text-36 font-semibold text-heading mb-32 md:leading-50"
                    font-customisation="section-heading"
                    color-customisation="page-heading"
                  >
                    {finalProduct.title}
                  </div>
                  <div
                    className="text-14 textsubtheme mt-12"
                    font-customisation="para-text"
                    color-customisation="page-body-text"
                  >
                    {finalProduct.categories?.map((category) => category.name).join(', ')}
                  </div>
                  <ProductAddToCart
                    product={product}
                    addToast={addToast}
                    cartProductQuantity={cartProductQuantity}
                    addProductToCart={addProductToCart}
                    subtractProductFromCart={subtractProductFromCart}
                    hocArgs={hocArgs}
                    storeType={storeType}
                    quickView={quickView}
                    wishListFeature={wishListFeature}
                  />
                </div>
              </div>
            </div>
            {(finalProduct.description || product.description) && !quickView ? (
              <div className={'bg-white md:mt-74 pb-16 rounded-md px-16'}>
                <div
                  className="text-theme text-14 md:text-24 mb-8 md:mb-24 font-semibold md:leading-loose"
                  font-customisation="section-heading"
                  color-customisation="page-heading"
                >
                  Product Description
                </div>
                <Editor
                  name="productLongDescription"
                  value={finalProduct.description || product.description}
                  readonly={true}
                  className="px-0 py-0 md:px-14 md:py-12"
                />
              </div>
            ) : null}
          </div>
        );
      }}
    />
  );
};

export default Event;
